<!--
 * @Author: your name
 * @Date: 2021-12-03 09:26:57
 * @LastEditTime: 2022-01-26 18:16:57
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \new-website-1123\src\views\special\fx101\page9.vue
-->
<template>
  <div class="fx101-page9 pt80">
    <div class="text-div">
      <ctitle titleb="远程智能报修"></ctitle>

      <p class="desc-p">上太物联平台实时监控，智能预警，及时报修，省心维护</p>
    </div>

    <div class="img-div">
      <img
        class="data-img"
        src="https://stkjiot.com/resources/special/stld/15.jpg"
        alt="上太科技"
      />
    </div>
  </div>
</template>

<script>
import ctitle from "@/components/sTitle/title1";
export default {
  name: "",
  components: {
    ctitle,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.fx101-page9 {
  position: relative;
  height: 100vh;
  text-align: center;
  justify-content: center;
  margin-top: 180px;
  .text-div {
    position: relative;
    z-index: 2;
    .desc-p {
      font-size: 18px;
      font-weight: 400;
      color: rgba($color: #fff, $alpha: 0.6);
      line-height: 30px;
      margin-top: 59px;
      margin-bottom: 34px;
    }
  }
  .data-img {
    width: 1500px;
    height: 700px;
    object-fit: cover;
  }
}

@media screen and (max-width: $mobile-width) {
  .fx101-page9 {
    height: auto;
    overflow: hidden;
    margin-top: 1.64rem;
    .text-div {
      .desc-p {
        font-size: 0.27rem;
        line-height: 0.44rem;
        margin: auto;
        margin-top: 0.36rem;
        margin-bottom: 0.27rem;
        width: 86%;
      }
    }
    .img-div {
      width: 86%;
      margin: auto;
      display: flex;
      justify-content: center;
      overflow: hidden;
      .data-img {
        width: 150%;
        height: unset;
        object-fit: cover;
        transform: translateX(-10%);
      }
    }
  }
}
</style>
